import moment from "moment";

// Get difference in Hours and Minutes
export const getDiffInHRAndMin = (departureTime: any, arrivalTime: any) => {
  let duration;
  const departureMoment = moment(departureTime);
  let arrivalMoment = moment(arrivalTime);
  if (arrivalMoment.isAfter(departureMoment)) {
    duration = moment.duration(arrivalMoment.diff(departureMoment));
  } else {
    // If arrival time is before departure time, add 1 day to arrival time
    arrivalMoment = arrivalMoment.add(1, "day");
    duration = moment.duration(arrivalMoment.diff(departureMoment));
  }
  // Calculate hours and minutes
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  return `${hours} h ${minutes} min`;
};

export const parseDuration = (duration: string): [number, number] => {
  if (!duration) return [0, 0];

  // Normalize string (remove spaces, make uppercase)
  const normalized = duration.toUpperCase().trim();

  let hours = 0;
  let minutes = 0;

  // Case 1: Format like "8H:20M" or "08H:20M"
  const regexHM = /(?:(\d+)\s*H)?[: ]?(?:(\d+)\s*M)?/i;
  const match = normalized.match(regexHM);
  if (match) {
    hours = parseInt(match[1] || "0", 10);
    minutes = parseInt(match[2] || "0", 10);
  }

  // Case 2: Format like "05:25" or "8:5"
  if (!match || (hours === 0 && minutes === 0)) {
    const parts = normalized
      .split(":")
      .map((x) => parseInt(x.replace(/\D/g, "") || "0", 10));
    if (parts.length === 2) {
      [hours, minutes] = parts;
    }
  }

  return [hours, minutes];
};

// Get total travel duration from segments
export const getTotalTravelDuration = (segments: any[]) => {
  let totalFlightMinutes = 0;
  let totalLayoverMinutes = 0;
  if (!segments?.length) return "0h 0min";
  const format = "MM/DD/YYYY HH:mm";
  for (let i = 0; i < segments?.length; i++) {
    // 1. Sum up flight durations
    // const [hrs, mins] = segments[i].Duration.split(":").map(Number);
    const [hrs, mins] = parseDuration(segments[i].Duration);
    totalFlightMinutes += hrs * 60 + mins;

    // 2. Sum up layovers between segments
    if (i < segments?.length - 1) {
      const arrival = moment(segments[i].Arrival_DateTime, format);
      const nextDeparture = moment(segments[i + 1].Departure_DateTime, format);
      const layover = nextDeparture.diff(arrival, "minutes");
      if (layover > 0) {
        totalLayoverMinutes += layover;
      }
    }
  }
  const totalTravelMinutes = totalFlightMinutes + totalLayoverMinutes;
  return formatMinToHRAndMin(totalTravelMinutes);
};

// Convert min to Hours and minutes
export const formatMinToHRAndMin = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  return `${formattedHours}h ${formattedMinutes}min`;
};

// Get arrival days message
export const getArrivalDayMessage = (departureTime: any, arrivalTime: any) => {
  const departureMoment = moment(departureTime);
  const arrivalMoment = moment(arrivalTime);
  const departureDate = departureMoment.startOf("day");
  const arrivalDate = arrivalMoment.startOf("day");
  const dayDifference = arrivalDate.diff(departureDate, "days");
  if (dayDifference > 0) {
    return `Flight Arrives after ${dayDifference} Day(s) `;
  } else {
    return "";
  }
};
